// Mock API utility functions for fetching data from public/mockdata

export const fetchObituaries = async () => {
  try {
    const response = await fetch('/mockdata/obituaries.json');
    if (!response.ok) throw new Error('Failed to fetch obituaries');
    return await response.json();
  } catch (error) {
    console.error('Error fetching obituaries:', error);
    return [];
  }
};

export const fetchObituaryById = async (id) => {
  try {
    const obituaries = await fetchObituaries();
    return obituaries.find(obit => obit.id === parseInt(id));
  } catch (error) {
    console.error('Error fetching obituary:', error);
    return null;
  }
};

export const fetchWreaths = async () => {
  try {
    const response = await fetch('/mockdata/wreaths.json');
    if (!response.ok) throw new Error('Failed to fetch wreaths');
    return await response.json();
  } catch (error) {
    console.error('Error fetching wreaths:', error);
    return [];
  }
};

export const fetchWreathById = async (id) => {
  try {
    const wreaths = await fetchWreaths();
    return wreaths.find(wreath => wreath.id === parseInt(id));
  } catch (error) {
    console.error('Error fetching wreath:', error);
    return null;
  }
};

export const fetchOrders = async () => {
  try {
    const response = await fetch('/mockdata/orders.json');
    if (!response.ok) throw new Error('Failed to fetch orders');
    return await response.json();
  } catch (error) {
    console.error('Error fetching orders:', error);
    return [];
  }
};

export const fetchOrderById = async (id) => {
  try {
    const orders = await fetchOrders();
    return orders.find(order => order.id === id);
  } catch (error) {
    console.error('Error fetching order:', error);
    return null;
  }
};

export const fetchUsers = async () => {
  try {
    const response = await fetch('/mockdata/users.json');
    if (!response.ok) throw new Error('Failed to fetch users');
    return await response.json();
  } catch (error) {
    console.error('Error fetching users:', error);
    return [];
  }
};

export const fetchUserById = async (id) => {
  try {
    const users = await fetchUsers();
    return users.find(user => user.id === parseInt(id));
  } catch (error) {
    console.error('Error fetching user:', error);
    return null;
  }
};

export const authenticateUser = async (email, password) => {
  try {
    const users = await fetchUsers();
    const user = users.find(u => u.email === email && u.password === password);
    if (user) {
      const { password: _, ...userWithoutPassword } = user;
      return userWithoutPassword;
    }
    return null;
  } catch (error) {
    console.error('Error authenticating user:', error);
    return null;
  }
};

export const fetchNotices = async () => {
  try {
    const response = await fetch('/mockdata/notices.json');
    if (!response.ok) throw new Error('Failed to fetch notices');
    return await response.json();
  } catch (error) {
    console.error('Error fetching notices:', error);
    return [];
  }
};

export const fetchNoticeById = async (id) => {
  try {
    const notices = await fetchNotices();
    return notices.find(notice => notice.id === parseInt(id));
  } catch (error) {
    console.error('Error fetching notice:', error);
    return null;
  }
};

export const fetchFAQs = async () => {
  try {
    const response = await fetch('/mockdata/faqs.json');
    if (!response.ok) throw new Error('Failed to fetch FAQs');
    return await response.json();
  } catch (error) {
    console.error('Error fetching FAQs:', error);
    return [];
  }
};

export const fetchInquiries = async () => {
  try {
    const response = await fetch('/mockdata/inquiries.json');
    if (!response.ok) throw new Error('Failed to fetch inquiries');
    return await response.json();
  } catch (error) {
    console.error('Error fetching inquiries:', error);
    return [];
  }
};

export const fetchInquiriesByUserId = async (userId) => {
  try {
    const inquiries = await fetchInquiries();
    return inquiries.filter(inquiry => inquiry.userId === parseInt(userId));
  } catch (error) {
    console.error('Error fetching user inquiries:', error);
    return [];
  }
};
